import React from 'react';
import { Checkbox, Tooltip } from '@mui/material';
import { Permission } from '../../../types/permissionType';
import { ElementItem } from '../Permissions.styles';
import { useTranslation } from 'react-i18next';

type Props = {
    permission: Permission & { isPerEntity?: boolean };
    entityId?: number;
    checked: boolean;
    onChange: () => void;
    disabled: boolean;
};

const PermissionCheckbox: React.FC<Props> = ({ permission, entityId, checked, onChange, disabled }) => {
    const { t } = useTranslation();
    
    const key = entityId
        ? `${permission.entityType}.${permission.permissionName}.${entityId}`
        : `${permission.entityType}.${permission.permissionName}`;

    return (
        <ElementItem key={key}>
            <Checkbox
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
             <Tooltip title={t(`permissionsPage.permissionName.${permission.permissionName}`)}>
              <span tabIndex={0}>{t(`permissionsPage.permissionName.${permission.permissionName}`)}</span>
          </Tooltip>
        </ElementItem>
    );
};

export default PermissionCheckbox;
